function Icon(props: any) {
    return (
        <span role="img" onClick={props.onClick} className={props.className}>
            {props.component()}
        </span>
    );
}

export const IconSocialDiscardFill = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M22.5 17.6284C22.5 11.7186 19.9095 6.92723 19.9095 6.92723C17.3221 4.94644 14.858 5.00119 14.858 5.00119L14.6063 5.295C17.6633 6.24906 19.0828 7.62646 19.0828 7.62646C17.4137 6.68608 15.5741 6.08689 13.6712 5.8647C12.4644 5.72886 11.245 5.74044 10.0403 5.89945C9.9318 5.89945 9.84124 5.9184 9.73488 5.93631C9.10515 5.99212 7.57612 6.23011 5.65324 7.09361C4.98877 7.40426 4.59177 7.6254 4.59177 7.6254C4.59177 7.6254 6.085 6.1743 9.31998 5.22023L9.1399 5.00014C9.1399 5.00014 6.67681 4.94644 4.08841 6.92828C4.08841 6.92828 1.5 11.7176 1.5 17.6284C1.5 17.6284 3.01008 20.2884 6.98325 20.4179C6.98325 20.4179 7.64773 19.5934 8.189 18.8952C5.90387 18.196 5.04247 16.728 5.04247 16.728C5.04247 16.728 5.22044 16.8575 5.54373 17.0408C5.56163 17.0587 5.57848 17.0776 5.61533 17.0945C5.66904 17.1324 5.7238 17.1503 5.7775 17.1871C6.22716 17.4441 6.67576 17.6452 7.08856 17.8116C7.82675 18.1054 8.7071 18.3992 9.73383 18.6014C11.2713 18.9026 12.8509 18.9089 14.3904 18.6193C15.2866 18.4592 16.1617 18.1949 16.9967 17.8305C17.6265 17.5915 18.3267 17.2419 19.0649 16.747C19.0649 16.747 18.1667 18.2518 15.8099 18.932C16.3502 19.6292 16.9978 20.4168 16.9988 20.4179C20.971 20.2894 22.5 17.6284 22.5 17.6284ZM8.52808 15.676C7.49714 15.676 6.64733 14.8894 6.64733 13.9279C6.64733 12.9665 7.47713 12.1799 8.52808 12.1799C9.57692 12.1799 10.4267 12.9665 10.4067 13.9279C10.4078 14.8894 9.57903 15.676 8.52808 15.676ZM15.255 15.676C14.224 15.676 13.3763 14.8894 13.3763 13.9279C13.3763 12.9665 14.2051 12.1799 15.255 12.1799C16.3049 12.1799 17.1357 12.9665 17.1357 13.9279C17.1357 14.8894 16.3059 15.676 15.255 15.676Z"
                    fill="currentColor"
                />
            </svg>
        )}
        {...props}
    />
);
export const IconSocialFacebookFill = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M20.01 3H3.99C3.441 3 3 3.441 3 3.99V20.01C3 20.559 3.441 21 3.99 21H12.612V14.034H10.263V11.316H12.612V9.309C12.612 6.987 14.034 5.718 16.104 5.718C17.094 5.718 17.949 5.79 18.201 5.826V8.256H16.761C15.636 8.256 15.42 8.796 15.42 9.588V11.325H18.111L17.76 14.052H15.42V21H20.01C20.559 21 21 20.559 21 20.01V3.99C21 3.441 20.559 3 20.01 3Z"
                    fill="currentColor"
                />
            </svg>
        )}
        {...props}
    />
);
export const IconSocialGithubFill = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M12 2C6.475 2 2 6.475 2 12C1.99887 14.0993 2.65882 16.1456 3.88622 17.8487C5.11362 19.5517 6.84615 20.8251 8.838 21.488C9.338 21.575 9.525 21.275 9.525 21.012C9.525 20.775 9.512 19.988 9.512 19.15C7 19.613 6.35 18.538 6.15 17.975C6.037 17.687 5.55 16.8 5.125 16.562C4.775 16.375 4.275 15.912 5.112 15.9C5.9 15.887 6.462 16.625 6.65 16.925C7.55 18.437 8.988 18.012 9.562 17.75C9.65 17.1 9.912 16.663 10.2 16.413C7.975 16.163 5.65 15.3 5.65 11.475C5.65 10.387 6.037 9.488 6.675 8.787C6.575 8.537 6.225 7.512 6.775 6.137C6.775 6.137 7.612 5.875 9.525 7.163C10.3391 6.93706 11.1802 6.82334 12.025 6.825C12.875 6.825 13.725 6.937 14.525 7.162C16.437 5.862 17.275 6.138 17.275 6.138C17.825 7.513 17.475 8.538 17.375 8.788C18.012 9.488 18.4 10.375 18.4 11.475C18.4 15.313 16.063 16.163 13.838 16.413C14.2 16.725 14.513 17.325 14.513 18.263C14.513 19.6 14.5 20.675 14.5 21.013C14.5 21.275 14.688 21.587 15.188 21.487C17.173 20.8168 18.8979 19.541 20.1199 17.8392C21.3419 16.1373 21.9994 14.0951 22 12C22 6.475 17.525 2 12 2Z"
                    fill="currentColor"
                />
            </svg>
        )}
        {...props}
    />
);
export const IconSocialInstagramFill = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <g clip-path="url(#clip0_4020_67739)">
                    <path
                        d="M12 3C14.4453 3 14.7504 3.009 15.7098 3.054C16.6683 3.099 17.3208 3.2493 17.895 3.4725C18.489 3.7011 18.9894 4.0107 19.4898 4.5102C19.9474 4.96011 20.3016 5.50433 20.5275 6.105C20.7498 6.6783 20.901 7.3317 20.946 8.2902C20.9883 9.2496 21 9.5547 21 12C21 14.4453 20.991 14.7504 20.946 15.7098C20.901 16.6683 20.7498 17.3208 20.5275 17.895C20.3022 18.496 19.948 19.0404 19.4898 19.4898C19.0398 19.9473 18.4956 20.3014 17.895 20.5275C17.3217 20.7498 16.6683 20.901 15.7098 20.946C14.7504 20.9883 14.4453 21 12 21C9.5547 21 9.2496 20.991 8.2902 20.946C7.3317 20.901 6.6792 20.7498 6.105 20.5275C5.50409 20.302 4.95977 19.9478 4.5102 19.4898C4.05247 19.04 3.69834 18.4957 3.4725 17.895C3.2493 17.3217 3.099 16.6683 3.054 15.7098C3.0117 14.7504 3 14.4453 3 12C3 9.5547 3.009 9.2496 3.054 8.2902C3.099 7.3308 3.2493 6.6792 3.4725 6.105C3.69771 5.50396 4.05192 4.95959 4.5102 4.5102C4.9599 4.05231 5.50419 3.69816 6.105 3.4725C6.6792 3.2493 7.3308 3.099 8.2902 3.054C9.2496 3.0117 9.5547 3 12 3ZM12 7.5C10.8065 7.5 9.66193 7.97411 8.81802 8.81802C7.97411 9.66193 7.5 10.8065 7.5 12C7.5 13.1935 7.97411 14.3381 8.81802 15.182C9.66193 16.0259 10.8065 16.5 12 16.5C13.1935 16.5 14.3381 16.0259 15.182 15.182C16.0259 14.3381 16.5 13.1935 16.5 12C16.5 10.8065 16.0259 9.66193 15.182 8.81802C14.3381 7.97411 13.1935 7.5 12 7.5ZM17.85 7.275C17.85 6.97663 17.7315 6.69048 17.5205 6.4795C17.3095 6.26853 17.0234 6.15 16.725 6.15C16.4266 6.15 16.1405 6.26853 15.9295 6.4795C15.7185 6.69048 15.6 6.97663 15.6 7.275C15.6 7.57337 15.7185 7.85952 15.9295 8.0705C16.1405 8.28147 16.4266 8.4 16.725 8.4C17.0234 8.4 17.3095 8.28147 17.5205 8.0705C17.7315 7.85952 17.85 7.57337 17.85 7.275ZM12 9.3C12.7161 9.3 13.4028 9.58446 13.9092 10.0908C14.4155 10.5972 14.7 11.2839 14.7 12C14.7 12.7161 14.4155 13.4028 13.9092 13.9092C13.4028 14.4155 12.7161 14.7 12 14.7C11.2839 14.7 10.5972 14.4155 10.0908 13.9092C9.58446 13.4028 9.3 12.7161 9.3 12C9.3 11.2839 9.58446 10.5972 10.0908 10.0908C10.5972 9.58446 11.2839 9.3 12 9.3Z"
                        fill="currentColor"
                    />
                </g>
                <defs>
                    <clipPath id="clip0_4020_67739">
                        <rect width="1em" height="1em" fill="white" />
                    </clipPath>
                </defs>
            </svg>
        )}
        {...props}
    />
);
export const IconSocialLinkedinFill = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M18.3372 18.339H15.6717V14.1622C15.6717 13.1662 15.6515 11.8845 14.2827 11.8845C12.893 11.8845 12.6807 12.9683 12.6807 14.0887V18.339H10.0152V9.75H12.5757V10.9207H12.6102C12.968 10.2457 13.838 9.53325 15.1377 9.53325C17.8385 9.53325 18.338 11.3108 18.338 13.6245L18.3372 18.339ZM7.0047 8.57475C6.1467 8.57475 5.45745 7.88025 5.45745 7.026C5.45745 6.1725 6.14745 5.47875 7.0047 5.47875C7.8597 5.47875 8.5527 6.1725 8.5527 7.026C8.5527 7.88025 7.85895 8.57475 7.0047 8.57475ZM8.3412 18.339H5.6682V9.75H8.3412V18.339ZM19.6707 3H4.3302C3.59595 3 3.00195 3.5805 3.00195 4.29675V19.7033C3.00195 20.4202 3.59595 21 4.3302 21H19.6685C20.402 21 21.002 20.4202 21.002 19.7033V4.29675C21.002 3.5805 20.402 3 19.6685 3H19.6707Z"
                    fill="currentColor"
                />
            </svg>
        )}
        {...props}
    />
);
export const IconSocialMailFill = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M18.3372 18.339H15.6717V14.1622C15.6717 13.1662 15.6515 11.8845 14.2827 11.8845C12.893 11.8845 12.6807 12.9683 12.6807 14.0887V18.339H10.0152V9.75H12.5757V10.9207H12.6102C12.968 10.2457 13.838 9.53325 15.1377 9.53325C17.8385 9.53325 18.338 11.3108 18.338 13.6245L18.3372 18.339ZM7.0047 8.57475C6.1467 8.57475 5.45745 7.88025 5.45745 7.026C5.45745 6.1725 6.14745 5.47875 7.0047 5.47875C7.8597 5.47875 8.5527 6.1725 8.5527 7.026C8.5527 7.88025 7.85895 8.57475 7.0047 8.57475ZM8.3412 18.339H5.6682V9.75H8.3412V18.339ZM19.6707 3H4.3302C3.59595 3 3.00195 3.5805 3.00195 4.29675V19.7033C3.00195 20.4202 3.59595 21 4.3302 21H19.6685C20.402 21 21.002 20.4202 21.002 19.7033V4.29675C21.002 3.5805 20.402 3 19.6685 3H19.6707Z"
                    fill="currentColor"
                />
            </svg>
        )}
        {...props}
    />
);
export const IconSocialMediumFill = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M21 5.20594C20.9998 4.62096 20.7673 4.06002 20.3536 3.64638C19.94 3.23274 19.379 3.00025 18.7941 3H5.20594C4.62096 3.00025 4.06002 3.23274 3.64638 3.64638C3.23274 4.06002 3.00025 4.62096 3 5.20594V18.7941C3.00025 19.379 3.23274 19.94 3.64638 20.3536C4.06002 20.7673 4.62096 20.9998 5.20594 21H18.7941C19.379 20.9998 19.94 20.7673 20.3536 20.3536C20.7673 19.94 20.9998 19.379 21 18.7941V5.20594ZM12.9684 12C12.9684 14.3709 11.0595 16.2928 8.70492 16.2928C6.35039 16.2928 4.44141 14.3709 4.44141 12C4.44141 9.62906 6.35016 7.70719 8.70492 7.70719C11.0597 7.70719 12.9684 9.6293 12.9684 12ZM17.6456 12C17.6456 14.2317 16.691 16.0416 15.5128 16.0416C14.3346 16.0416 13.3828 14.2317 13.3828 12C13.3828 9.76828 14.3372 7.95867 15.5145 7.95867C16.6917 7.95867 17.6473 9.76781 17.6473 12H17.6456ZM19.5586 12C19.5586 13.999 19.223 15.6204 18.8086 15.6204C18.3942 15.6204 18.0586 13.9995 18.0586 12C18.0586 10.0005 18.3942 8.37961 18.8086 8.37961C19.223 8.37961 19.5586 10.0005 19.5586 12Z"
                    fill="currentColor"
                />
            </svg>
        )}
        {...props}
    />
);
export const IconSocialOpenseaFill = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M20.3147 17.5557C21.4135 15.9112 22 13.9778 22 12C22 9.34783 20.9464 6.8043 19.0711 4.92893C17.1957 3.05357 14.6522 2 12 2C10.0222 2 8.08879 2.58649 6.4443 3.6853C4.79981 4.78412 3.51809 6.3459 2.76121 8.17316C2.00433 10.0004 1.8063 12.0111 2.19215 13.9509C2.578 15.8907 3.53041 17.6725 4.92894 19.0711C6.32746 20.4696 8.10929 21.422 10.0491 21.8078C11.9889 22.1937 13.9996 21.9957 15.8268 21.2388C17.6541 20.4819 19.2159 19.2002 20.3147 17.5557ZM18.528 13.0919V13.7359C18.5283 13.7537 18.5233 13.7711 18.5137 13.7861C18.5041 13.801 18.4902 13.8128 18.474 13.8199C18.274 13.9059 17.582 14.2199 17.296 14.6199C17.1372 14.8412 16.9863 15.083 16.8346 15.3259C16.2873 16.2031 15.7301 17.0959 14.756 17.0959H9.54396C9.10396 17.0954 8.66837 17.0081 8.26211 16.8391C7.85586 16.6702 7.48689 16.4227 7.17632 16.1111C6.86575 15.7994 6.61966 15.4295 6.45213 15.0227C6.2846 14.6158 6.19891 14.1799 6.19996 13.7399V13.6799C6.20048 13.6564 6.2102 13.634 6.22702 13.6176C6.24384 13.6011 6.26643 13.5919 6.28996 13.5919H9.19996C9.21364 13.5924 9.22707 13.5957 9.23943 13.6015C9.25179 13.6074 9.26281 13.6158 9.27181 13.6261C9.28081 13.6364 9.2876 13.6485 9.29175 13.6615C9.2959 13.6745 9.29734 13.6883 9.29596 13.7019C9.2747 13.8941 9.31089 14.0883 9.39996 14.2599C9.48437 14.4307 9.61492 14.5744 9.77681 14.6748C9.9387 14.7752 10.1255 14.8282 10.316 14.8279H11.754V13.7059H10.326C10.3094 13.7056 10.2932 13.7007 10.2791 13.692C10.265 13.6832 10.2536 13.6707 10.246 13.656C10.2384 13.6412 10.235 13.6247 10.236 13.6081C10.2371 13.5916 10.2426 13.5756 10.252 13.5619L10.304 13.4859C10.438 13.2859 10.63 12.9979 10.822 12.6599C10.9556 12.4287 11.0751 12.1896 11.18 11.9439C11.1926 11.9161 11.2037 11.8874 11.2146 11.859C11.221 11.8425 11.2273 11.8261 11.234 11.8099L11.2479 11.7714L11.2479 11.7714C11.271 11.7074 11.2933 11.646 11.31 11.5859C11.3194 11.5519 11.3284 11.5219 11.337 11.4934L11.337 11.4934L11.337 11.4933C11.3465 11.4615 11.3555 11.4315 11.364 11.3999C11.4113 11.1845 11.4341 10.9644 11.432 10.7439C11.432 10.6539 11.432 10.5599 11.42 10.4719C11.4138 10.4268 11.4098 10.3755 11.4057 10.3234C11.4018 10.2739 11.3978 10.2238 11.392 10.1779C11.38 10.0839 11.368 10.0059 11.352 9.91791C11.33 9.78791 11.302 9.65791 11.27 9.51791L11.258 9.46791L11.252 9.44543L11.252 9.44538C11.2302 9.36378 11.2096 9.28636 11.184 9.20391C11.102 8.92391 11.01 8.64991 10.91 8.40391C10.874 8.30191 10.834 8.20391 10.792 8.10791C10.732 7.95991 10.67 7.82591 10.614 7.70791C10.584 7.64991 10.56 7.59791 10.536 7.54391C10.512 7.48991 10.48 7.42391 10.45 7.36591C10.42 7.30791 10.406 7.27991 10.39 7.23991L10.214 6.91591C10.2087 6.9061 10.2064 6.89498 10.2072 6.88388C10.2081 6.87278 10.2122 6.86216 10.2189 6.8533C10.2257 6.84445 10.2348 6.83772 10.2453 6.83392C10.2558 6.83013 10.2671 6.82943 10.278 6.83191L11.378 7.12991L11.522 7.17191L11.682 7.21591L11.74 7.23191V6.57191C11.7394 6.49648 11.7539 6.42169 11.7826 6.35192C11.8113 6.28215 11.8536 6.21879 11.907 6.16554C11.9604 6.11229 12.024 6.07022 12.0938 6.04178C12.1637 6.01335 12.2385 5.99911 12.314 5.99991C12.3885 5.99933 12.4625 6.01392 12.5312 6.0428C12.6 6.07168 12.6622 6.11425 12.714 6.16791C12.8194 6.27445 12.879 6.41802 12.88 6.56791V7.53791L12.998 7.56991L13.024 7.58391L13.146 7.67591C13.1698 7.69411 13.1944 7.7149 13.2207 7.73717L13.2207 7.73718C13.2406 7.75407 13.2615 7.7718 13.284 7.78991C13.3804 7.86816 13.4951 7.96958 13.6189 8.07913L13.656 8.11191L13.656 8.11191C13.692 8.14391 13.728 8.17591 13.762 8.20991C13.94 8.37591 14.14 8.56991 14.332 8.78591C14.386 8.84791 14.438 8.90791 14.492 8.97391L14.5278 9.01725C14.5702 9.06835 14.6125 9.1193 14.65 9.17391C14.6737 9.20848 14.7066 9.25184 14.7419 9.29819L14.7419 9.29824L14.7419 9.29825C14.7781 9.34573 14.8166 9.39635 14.85 9.44391C14.8615 9.46201 14.874 9.48045 14.8866 9.49894L14.8866 9.49895C14.9046 9.52542 14.9227 9.55201 14.938 9.57791C15.0153 9.69491 15.0867 9.81573 15.152 9.93991C15.18 9.99591 15.208 10.0579 15.232 10.1179C15.3053 10.2768 15.3617 10.4431 15.4 10.6139C15.4118 10.6496 15.4198 10.6865 15.424 10.7239C15.4349 10.7746 15.4416 10.8261 15.444 10.8779C15.4594 11.0526 15.4479 11.2287 15.41 11.3999C15.394 11.4719 15.374 11.5399 15.35 11.6139C15.326 11.6879 15.3 11.7559 15.268 11.8259C15.2062 11.971 15.1326 12.1108 15.048 12.2439C15.0237 12.2873 14.9948 12.3322 14.9667 12.376L14.9667 12.3761L14.954 12.3959C14.9365 12.4232 14.916 12.4512 14.8958 12.4787L14.8957 12.4788L14.8957 12.4788C14.879 12.5016 14.8624 12.5242 14.848 12.5459C14.816 12.5939 14.754 12.6719 14.704 12.7299C14.6613 12.7905 14.6152 12.8486 14.566 12.9039C14.498 12.9859 14.432 13.0619 14.366 13.1359C14.3253 13.1856 14.2819 13.233 14.236 13.2779C14.2006 13.3181 14.1639 13.3544 14.1301 13.3879L14.1301 13.3879L14.106 13.4119C14.0722 13.4457 14.0055 13.5095 13.9567 13.5562L13.9567 13.5562L13.932 13.5799L13.818 13.6819C13.81 13.6897 13.8007 13.6958 13.7904 13.6999C13.7801 13.704 13.769 13.7061 13.758 13.7059H12.878V14.8279H13.98C14.2258 14.8284 14.4636 14.7403 14.65 14.5799C14.8895 14.3707 15.1165 14.1477 15.33 13.9119C15.3408 13.8989 15.3555 13.8898 15.372 13.8859L18.414 12.9999C18.4278 12.9961 18.4423 12.9956 18.4563 12.9985C18.4703 13.0014 18.4835 13.0076 18.4946 13.0166C18.5058 13.0256 18.5146 13.0371 18.5204 13.0502C18.5262 13.0633 18.5288 13.0776 18.528 13.0919ZM6.93409 12.336L6.97609 12.268L9.57809 8.20003C9.58699 8.18686 9.59922 8.17628 9.61353 8.16936C9.62784 8.16245 9.64373 8.15945 9.65958 8.16067C9.67543 8.16188 9.69068 8.16728 9.70376 8.1763C9.71685 8.18533 9.72732 8.19765 9.73409 8.21203C10.1681 9.18603 10.5341 10.398 10.3681 11.152C10.2491 11.5463 10.0768 11.9224 9.85609 12.27C9.82609 12.326 9.79409 12.382 9.75809 12.436C9.74985 12.448 9.73878 12.4577 9.72587 12.4643C9.71296 12.471 9.6986 12.4743 9.68409 12.474H7.01009C6.99374 12.4747 6.97752 12.4708 6.96326 12.4628C6.94901 12.4547 6.93727 12.4429 6.92937 12.4286C6.92148 12.4142 6.91774 12.398 6.91857 12.3816C6.9194 12.3653 6.92478 12.3495 6.93409 12.336Z"
                    fill="currentColor"
                />
            </svg>
        )}
        {...props}
    />
);
export const IconSocialProtocolFill = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <g clip-path="url(#clip0_4020_67731)">
                    <path
                        d="M16.1667 4.63636H18.6667C18.8877 4.63636 19.0996 4.72256 19.2559 4.876C19.4122 5.02944 19.5 5.23755 19.5 5.45455V20.1818C19.5 20.3988 19.4122 20.6069 19.2559 20.7604C19.0996 20.9138 18.8877 21 18.6667 21H5.33333C5.11232 21 4.90036 20.9138 4.74408 20.7604C4.5878 20.6069 4.5 20.3988 4.5 20.1818V5.45455C4.5 5.23755 4.5878 5.02944 4.74408 4.876C4.90036 4.72256 5.11232 4.63636 5.33333 4.63636H7.83333V3H9.5V4.63636H14.5V3H16.1667V4.63636ZM7.83333 9.54545V11.1818H16.1667V9.54545H7.83333ZM7.83333 12.8182V14.4545H16.1667V12.8182H7.83333Z"
                        fill="currentColor"
                    />
                </g>
                <defs>
                    <clipPath id="clip0_4020_67731">
                        <rect width="1em" height="1em" fill="white" />
                    </clipPath>
                </defs>
            </svg>
        )}
        {...props}
    />
);
export const IconSocialTelegramFill = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M12 2C6.47712 2 2 6.4772 2 12C2 17.5228 6.4772 22 12 22C17.5228 22 22 17.5228 22 12C22 6.4772 17.5229 2 12 2ZM16.7688 8.50288C16.7398 8.90752 16.5086 10.3237 16.2774 11.8555C15.9306 14.0235 15.5549 16.393 15.5549 16.393C15.5549 16.393 15.4971 17.0578 15.0058 17.1734C14.5144 17.289 13.7052 16.7688 13.5607 16.6534C13.4451 16.5667 11.3931 15.2661 10.6417 14.6303C10.4394 14.4569 10.2082 14.1103 10.6706 13.7054C11.711 12.7517 12.9538 11.5667 13.7052 10.8153C14.0521 10.4685 14.3988 9.6592 12.9538 10.6418C10.9018 12.0578 8.87864 13.3875 8.87864 13.3875C8.87864 13.3875 8.416 13.6763 7.5492 13.416C6.6824 13.1557 5.67056 12.809 5.67056 12.809C5.67056 12.809 4.97696 12.3755 6.16184 11.913C6.16184 11.913 11.1618 9.86104 12.8959 9.13848C13.5607 8.84944 15.815 7.92456 15.815 7.92456C15.815 7.92456 16.8555 7.52 16.7688 8.50288Z"
                    fill="currentColor"
                />
            </svg>
        )}
        {...props}
    />
);
export const IconSocialTelegram2Fill = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M20.9909 5.16902C20.9397 5.88487 20.5307 8.39021 20.1216 11.1002C19.5081 14.9356 18.8434 19.1276 18.8434 19.1276C18.8434 19.1276 18.7412 20.3037 17.8719 20.5082C17.0026 20.7127 15.5711 19.7923 15.3155 19.5883C15.111 19.4348 11.4808 17.1339 10.1514 16.0091C9.79345 15.7023 9.38443 15.0892 10.2025 14.3729C12.0432 12.6856 14.2417 10.5893 15.5711 9.25991C16.1847 8.64638 16.7981 7.21468 14.2417 8.95307C10.6115 11.4581 7.03237 13.8105 7.03237 13.8105C7.03237 13.8105 6.2139 14.3214 4.68044 13.8609C3.14698 13.4003 1.35692 12.7871 1.35692 12.7871C1.35692 12.7871 0.129868 12.0201 2.22605 11.202C2.22605 11.202 11.0716 7.57175 14.1394 6.29347C15.3155 5.78212 19.3036 4.14591 19.3036 4.14591C19.3036 4.14591 21.1443 3.4302 20.9909 5.16902Z"
                    fill="currentColor"
                />
            </svg>
        )}
        {...props}
    />
);
export const IconSocialTgBotFill = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M11.9996 4C8.49618 4 5.65601 6.85634 5.65601 10.3798V16.009C5.65601 17.8743 7.15954 19.3865 9.01436 19.3865H14.9848C16.8396 19.3865 18.3431 17.8743 18.3431 16.009V10.3798C18.3431 6.85634 15.503 4 11.9996 4ZM16.4774 10.3798C16.4774 11.553 15.3237 12.2562 14.157 12.2562H9.84211C8.67546 12.2562 7.52176 11.553 7.52176 10.3798C7.52176 7.89262 9.52653 5.8764 11.9996 5.8764C14.4726 5.8764 16.4774 7.89262 16.4774 10.3798Z"
                    fill="currentColor"
                />
                <rect
                    x="19.2883"
                    y="10.6133"
                    width="3.71166"
                    height="6.88344"
                    rx="1.85583"
                    fill="currentColor"
                />
                <rect
                    x="1"
                    y="10.6133"
                    width="3.71166"
                    height="6.88344"
                    rx="1.85583"
                    fill="currentColor"
                />
            </svg>
        )}
        {...props}
    />
);
export const IconSocialTwitterFill = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M21.9549 5.9296C21.2054 6.26368 20.4108 6.48039 19.5982 6.57971C20.456 6.06504 21.0971 5.26143 21.4041 4.31334C20.6095 4.77384 19.7336 5.10793 18.7946 5.29754C17.5305 3.94314 15.5079 3.60906 13.8646 4.4849C12.2212 5.36075 11.3815 7.22982 11.8059 9.03569C8.41083 8.87316 5.386 7.22982 3.36343 4.75578C3.00226 5.38784 2.80361 6.10116 2.81264 6.8235C2.81264 8.25014 3.53499 9.49619 4.63657 10.2366C3.98646 10.2185 3.34537 10.038 2.77652 9.72192V9.7761C2.77652 11.7264 4.14898 13.4059 6.06321 13.7942C5.45824 13.9567 4.83521 13.9838 4.22122 13.8664C4.76298 15.5368 6.29797 16.6835 8.05869 16.7106C6.60497 17.8483 4.81716 18.4623 2.97517 18.4623C2.65011 18.4623 2.32506 18.4443 2 18.4082C3.8781 19.6091 6.06321 20.2501 8.29345 20.2501C15.833 20.2501 19.9594 14.0018 19.9594 8.59326C19.9594 8.4217 19.9594 8.24111 19.9503 8.06955C20.754 7.49167 21.4492 6.76933 22 5.94766L21.9549 5.9296Z"
                    fill="currentColor"
                />
            </svg>
        )}
        {...props}
    />
);
export const IconSocialWebsiteFill = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M12.9 17.5V19.3H16.5V21.1H7.50003V19.3H11.1V17.5H3.89284C3.77465 17.4993 3.65777 17.4752 3.54889 17.4293C3.44001 17.3833 3.34127 17.3163 3.25833 17.2321C3.17539 17.1479 3.10988 17.0482 3.06556 16.9386C3.02123 16.8291 2.99897 16.7119 3.00004 16.5937V4.9063C3.00004 4.4059 3.40954 4 3.89284 4H20.1072C20.6004 4 21 4.4041 21 4.9063V16.5937C21 17.0941 20.5905 17.5 20.1072 17.5H12.9ZM7.5 8H16.5V9.8H7.5V8ZM12 12H7.5V13.8H12V12Z"
                    fill="currentColor"
                />
            </svg>
        )}
        {...props}
    />
);
export const IconSocialWeiboFill = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <g clip-path="url(#clip0_4020_67743)">
                    <path
                        d="M10.4031 18.4459C7.09152 18.7838 4.23257 17.2423 4.01732 15.008C3.80207 12.7714 6.31332 10.6877 9.62212 10.35C12.9337 10.0121 15.7926 11.5536 16.0055 13.7879C16.2235 16.0247 13.7124 18.1112 10.4034 18.4462L10.4031 18.4459ZM17.0236 11.0227C16.7422 10.9347 16.549 10.8779 16.6953 10.4976C17.0153 9.6715 17.0485 8.959 16.7008 8.44825C16.0522 7.49467 14.275 7.54553 12.2384 8.42274C12.2384 8.42274 11.5982 8.70948 11.7638 8.18995C12.0756 7.15381 12.0287 6.28806 11.543 5.7856C10.4391 4.64724 7.50014 5.82817 4.98069 8.41989C3.09559 10.3585 2 12.4165 2 14.1961C2 17.5968 6.24159 19.6666 10.3893 19.6666C15.8283 19.6666 19.4469 16.4163 19.4469 13.8359C19.4496 12.2746 18.1719 11.3889 17.0236 11.0227Z"
                        fill="currentColor"
                    />
                    <path
                        d="M20.6358 4.79759C19.3222 3.29872 17.3849 2.72816 15.5967 3.11988C15.4985 3.14151 15.4054 3.18282 15.3227 3.24145C15.24 3.30009 15.1693 3.37491 15.1147 3.46164C15.0602 3.54836 15.0227 3.6453 15.0046 3.74691C14.9864 3.84852 14.9879 3.95282 15.0089 4.05384C15.0299 4.15487 15.0701 4.25065 15.1271 4.33571C15.1841 4.42077 15.2568 4.49345 15.3411 4.54959C15.4254 4.60574 15.5197 4.64425 15.6184 4.66294C15.7172 4.68162 15.8186 4.68011 15.9168 4.65849C17.189 4.38028 18.5661 4.78621 19.4988 5.85071C20.4315 6.9152 20.6854 8.36597 20.2853 9.63741C20.2259 9.83528 20.2446 10.0493 20.3374 10.233C20.4302 10.4168 20.5896 10.5556 20.7812 10.6194C20.9727 10.6832 21.181 10.6668 21.3609 10.5738C21.5408 10.4808 21.6778 10.3187 21.7424 10.1226V10.1197C22.3054 8.33419 21.9494 6.29312 20.6358 4.79717"
                        fill="currentColor"
                    />
                    <path
                        d="M18.6186 6.67134C18.3156 6.32536 17.9292 6.06782 17.4984 5.92476C17.0676 5.7817 16.6077 5.75819 16.1653 5.85662C15.8093 5.93324 15.5829 6.2966 15.6575 6.66281C15.7348 7.02902 16.0852 7.2618 16.4382 7.18234C16.6546 7.13405 16.8795 7.14536 17.0903 7.21514C17.3011 7.28492 17.4902 7.41069 17.6386 7.57974C17.787 7.74879 17.8894 7.95514 17.9354 8.17794C17.9814 8.40073 17.9695 8.63207 17.9007 8.84859C17.8469 9.01986 17.8615 9.20611 17.9412 9.36635C18.0209 9.52659 18.1592 9.6477 18.3257 9.70304C18.4922 9.75838 18.6733 9.74342 18.829 9.66144C18.9848 9.57946 19.1026 9.43718 19.1564 9.2659C19.4296 8.39447 19.2585 7.40058 18.6183 6.67134"
                        fill="currentColor"
                    />
                    <path
                        d="M10.5852 14.398C10.4693 14.6023 10.2127 14.6991 10.014 14.6137C9.81531 14.5314 9.75456 14.3015 9.86759 14.1027C9.98355 13.904 10.2291 13.8075 10.4251 13.887C10.6238 13.9608 10.6955 14.1907 10.5851 14.398H10.5852ZM9.52801 15.7889C9.20795 16.3141 8.52073 16.544 8.0047 16.3027C7.49695 16.0642 7.34513 15.4539 7.66528 14.9401C7.98241 14.4292 8.64499 14.2021 9.15826 14.4235C9.67707 14.6534 9.84263 15.258 9.52801 15.7889ZM10.7315 12.0703C9.15574 11.6472 7.37579 12.4563 6.69134 13.8841C5.99315 15.3404 6.6693 16.9584 8.25881 17.4865C9.90955 18.0343 11.8519 17.1937 12.528 15.6242C13.1958 14.0857 12.3624 12.5042 10.7315 12.0703Z"
                        fill="currentColor"
                    />
                </g>
                <defs>
                    <clipPath id="clip0_4020_67743">
                        <rect
                            width="20"
                            height="16.6667"
                            fill="white"
                            transform="translate(2 3)"
                        />
                    </clipPath>
                </defs>
            </svg>
        )}
        {...props}
    />
);

export const IconSocialWhitePaperFill = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M5.80005 3.9C5.80005 3.40294 6.20298 3 6.70005 3H19.3C19.7971 3 20.2 3.40294 20.2 3.9V20.1C20.2 20.5971 19.7971 21 19.3 21H6.70005C6.20298 21 5.80005 20.5971 5.80005 20.1V17.4H4.9C4.40294 17.4 4 16.997 4 16.5C4 16.0029 4.40294 15.6 4.9 15.6H5.80005V12.9H4.9C4.40294 12.9 4 12.497 4 12C4 11.5029 4.40294 11.1 4.9 11.1H5.80005V8.39998H4.9C4.40294 8.39998 4 7.99703 4 7.49998C4 7.00292 4.40294 6.59998 4.9 6.59998H5.80005V3.9ZM17.4769 4.79718L17.5234 19.1971L15.7234 19.2029L15.677 4.80299L17.4769 4.79718Z"
                    fill="currentColor"
                />
            </svg>
        )}
        {...props}
    />
);

export const IconSocialXFill = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M17.7263 3H20.7798L14.1087 10.6246L21.9567 21H15.8118L10.9989 14.7074L5.49183 21H2.43644L9.57183 12.8446L2.04321 3H8.34414L12.6946 8.75169L17.7263 3ZM16.6546 19.1723H18.3466L7.42475 4.73169H5.60906L16.6546 19.1723Z"
                    fill="currentColor"
                />
            </svg>
        )}
        {...props}
    />
);
export const IconSocialYoutubeFill = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <g clip-path="url(#clip0_4020_67735)">
                    <path
                        d="M21.0658 6.84188C21.5 8.5125 21.5 12 21.5 12C21.5 12 21.5 15.4875 21.0658 17.1581C20.8245 18.0816 20.1187 18.8081 19.2247 19.0538C17.6012 19.5 12 19.5 12 19.5C12 19.5 6.40165 19.5 4.77525 19.0538C3.8775 18.8044 3.1726 18.0788 2.93415 17.1581C2.5 15.4875 2.5 12 2.5 12C2.5 12 2.5 8.5125 2.93415 6.84188C3.17545 5.91844 3.8813 5.19187 4.77525 4.94625C6.40165 4.5 12 4.5 12 4.5C12 4.5 17.6012 4.5 19.2247 4.94625C20.1225 5.19562 20.8274 5.92125 21.0658 6.84188ZM10.1 15.2812L15.8 12L10.1 8.71875V15.2812Z"
                        fill="currentColor"
                    />
                </g>
                <defs>
                    <clipPath id="clip0_4020_67735">
                        <rect width="1em" height="1em" fill="white" />
                    </clipPath>
                </defs>
            </svg>
        )}
        {...props}
    />
);
